// extracted by mini-css-extract-plugin
module.exports = {"enrollment":"enrollment_enrollment__33-Nl","courses":"enrollment_courses__q4l1Q","thumb":"enrollment_thumb__3OYiV","addCourse":"enrollment_addCourse__26fDA"};